export default __webpack_public_path__ + "static/media/8413482.8ddacbe4.jpeg";